import { Card, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export const AbsenceNoticeConfirmContent: FC<{ comment: string }> = ({ comment }) => {
  const { formatMessage } = useIntl();

  return (
    <Stack gap={2} mt={2}>
      <Typography variant="h3" color="text.primary">
        {formatMessage({ id: 'attendance-justification-OpenWithAbsenceNotice-Description' })}
      </Typography>
      <Card sx={{ p: 1 }}>
        <Stack gap={0.25}>
          <Typography variant="h4" color="text.secondary">
            {formatMessage({ id: 'attendance-AbsenceNotice' })}
          </Typography>
          <Typography color="primary.main" maxHeight={200} overflow="auto">
            {comment}
          </Typography>
        </Stack>
      </Card>
    </Stack>
  );
};
